/* Sampson smart cart recommendations: whole-cart aware.
   Resolution MATCHES the PDP 'Pairs well with' (sampson-crosssell): curated assets/crosssell.json
   (handle -> [complement_handles]) PRIMARY, native /recommendations?intent=complementary FALLBACK.
   For every NON-gift cart item, gather complements, merge + frequency-score, EXCLUDE in-cart items +
   the 3 $0 gift variants, render top 8. Loads globally; survives drawer re-renders; loop-guarded. */

/* Sampson shared cart-write lock (idempotent; defined by whichever cart script loads first).
   Serializes every cart-mutating write across product-form, gift-ladder, cart-items and
   smart-recs so two /cart/add.js|/cart/change.js writes never overlap -> no Shopify 422/429
   race -> no silently-swallowed add. Deadman-releases the queue after 12s so a hung fetch
   can't freeze all future cart writes. */
window.SampsonCartLock = window.SampsonCartLock || (function () {
  var tail = Promise.resolve();
  return { run: function (fn) {
    var result = tail.then(fn, fn);
    tail = new Promise(function (release) {
      var done = false, fin = function () { if (!done) { done = true; release(); } };
      result.then(fin, fin); setTimeout(fin, 12000);
    });
    return result;
  } };
})();

(function(){
  if (window.__csrInit) return; window.__csrInit = true;
  var GIFTV = [43484410019971, 47310100365443, 47291986968707];
  var FR = (document.documentElement.lang||'en').slice(0,2) === 'fr';
  var running = false, dbt = null, lastSig = null, MAP = null, mapTried = false;

  function host(){ return document.getElementById('cart-smart-recs'); }
  function money(c){ var n=(c/100).toFixed(2); return FR ? n.replace('.',',')+' $' : '$'+n; }
  function withW(u){ if(!u) return ''; return u + (u.indexOf('?')>-1?'&':'?') + 'width=300'; }
  function sigOf(cart){ return (cart.items||[]).map(function(i){return i.variant_id+':'+i.quantity;}).join(','); }

  function loadMap(){
    if (MAP || mapTried) return Promise.resolve(MAP);
    var h = host(); var url = h && h.dataset.map;
    if (!url){ mapTried = true; return Promise.resolve(null); }
    return fetch(url).then(function(r){ return r.ok ? r.json() : null; })
      .then(function(j){ MAP = j || {}; mapTried = true; return MAP; })
      .catch(function(){ mapTried = true; MAP = {}; return MAP; });
  }
  function nativeComps(pid){
    return fetch('/recommendations/products.json?product_id='+encodeURIComponent(pid)+'&intent=complementary&limit=10')
      .then(function(r){ return r.ok ? r.json() : {products:[]}; })
      .then(function(d){ return (d.products||[]).map(function(p){ return p.handle; }); }).catch(function(){ return []; });
  }
  function prod(h){ return fetch('/products/'+h+'.js').then(function(r){ return r.ok ? r.json() : null; }).catch(function(){ return null; }); }
  function card(p){
    var img = p.featured_image || (p.images && p.images[0]) || '';
    var vid = (p.variants && p.variants[0] && p.variants[0].id) || p.id;
    return '<div class="csr-card"><a href="'+p.url+'"><span class="csr-img">'+(img?'<img src="'+withW(img)+'" alt="" loading="lazy">':'')+'</span>'
      + '<span class="csr-nm">'+p.title+'</span></a><div class="csr-foot"><span class="csr-pr">'+money(p.price)+'</span>'
      + '<button class="csr-add" data-v="'+vid+'">'+(FR?'Ajouter +':'Add +')+'</button></div></div>';
  }
  function wireNav(h){   // prev/next arrows — mirrors the PDP 'Pairs well with' (sampson-crosssell) arrow behavior
    var track = h.querySelector('.csr-track');
    var prev = h.querySelector('[data-csr-prev]'), next = h.querySelector('[data-csr-next]'), navg = h.querySelector('.csr-navgroup');
    if(!track || !prev || !next) return;
    var step = 142;   // card 132 + gap 10
    function upd(){ var over = track.scrollWidth > track.clientWidth+2; if(navg) navg.style.display = over?'':'none'; prev.disabled = track.scrollLeft<=2; next.disabled = track.scrollLeft+track.clientWidth>=track.scrollWidth-2; }
    prev.onclick = function(){ track.scrollBy({left:-step*2, behavior:'smooth'}); };
    next.onclick = function(){ track.scrollBy({left: step*2, behavior:'smooth'}); };
    track.addEventListener('scroll', upd); setTimeout(upd, 50);
  }
  function wire(h){
    h.querySelectorAll('.csr-add').forEach(function(b){
      b.onclick = function(){
        var cd = document.querySelector('cart-drawer');
        var secs = ['cart-icon-bubble']; if (cd && cd.closest('.shopify-section')) secs.push(cd.closest('.shopify-section').id.replace('shopify-section-',''));
        window.SampsonCartLock.run(function(){
          return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/javascript'},body:JSON.stringify({items:[{id:+b.dataset.v,quantity:1}],sections:secs,sections_url:location.pathname})}).then(function(r){return r.json();});
        }).then(function(d){ if(cd&&cd.renderContents) cd.renderContents(d,true); }).catch(function(){});
      };
    });
  }
  function run(){
    if (running) return; running = true;
    var h = host(); if (!h){ running = false; return; }
    Promise.all([ fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}), loadMap() ]).then(function(res){
      var cart = res[0], map = res[1] || {};
      var sig = sigOf(cart);
      if (sig === lastSig && h.children.length){ running = false; return; }
      var inCartH = {}, inCartP = {};
      (cart.items||[]).forEach(function(it){ inCartH[it.handle] = 1; inCartP[it.product_id] = 1; });
      var anchors = (cart.items||[]).filter(function(it){ return GIFTV.indexOf(it.variant_id) < 0; });
      if (!anchors.length){ h.innerHTML = ''; lastSig = sig; running = false; return; }
      Promise.all(anchors.map(function(it){
        var curated = map[it.handle];
        if (curated && curated.length) return Promise.resolve(curated);   // crosssell.json PRIMARY
        return nativeComps(it.product_id);                                // native FALLBACK
      })).then(function(lists){
        var score = {};
        lists.forEach(function(hs){ (hs||[]).forEach(function(hd){ if (inCartH[hd]) return; score[hd] = (score[hd]||0)+1; }); });
        var ranked = Object.keys(score).sort(function(a,b){ return score[b]-score[a]; }).slice(0,12);
        lastSig = sig;
        if (!ranked.length){ h.innerHTML = ''; running = false; return; }
        Promise.all(ranked.map(prod)).then(function(prods){
          var out = [];
          prods.forEach(function(p){
            if (!p) return;
            var vid = (p.variants && p.variants[0] && p.variants[0].id) || p.id;
            if (GIFTV.indexOf(vid) >= 0) return;     // gift SKU
            if (inCartP[p.id]) return;               // already in cart
            if (p.available === false) return;
            out.push(p);
          });
          out = out.slice(0,8);
          if (!out.length){ h.innerHTML = ''; running = false; return; }
          var heading = h.dataset.heading || (FR?'Se marie bien avec':'You may also like');
          h.innerHTML = '<div class="csr-head"><span class="csr-eyebrow">'+heading+'</span><span class="csr-rule"></span>'
            + '<div class="csr-navgroup"><button class="csr-nav" data-csr-prev aria-label="'+(FR?'Précédent':'Previous')+'">‹</button><button class="csr-nav" data-csr-next aria-label="'+(FR?'Suivant':'Next')+'">›</button></div></div>'
            + '<div class="csr-track">'+out.map(card).join('')+'</div>';
          wire(h); wireNav(h); running = false;
        }).catch(function(){ running = false; });
      }).catch(function(){ running = false; });
    }).catch(function(){ running = false; });
  }
  function schedule(){ clearTimeout(dbt); dbt = setTimeout(run, 160); }
  function init(){
    var cd = document.querySelector('cart-drawer'); if (!cd) return;
    new MutationObserver(function(){ if (!running) schedule(); }).observe(cd, {childList:true, subtree:true});
    document.addEventListener('cart:refresh', run);
    run();
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();

